import { useEffect, useState } from "react";
import { Modal, Text, Button, Group, Stack, ThemeIcon } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import { useLocation } from "wouter";

/**
 * Listens for the global "upgrade-required" event (dispatched by the shared api.js
 * on any 402 plan-gate response) and shows an upgrade prompt. Mount once in App.
 */
export default function UpgradeRequiredModal() {
  const [detail, setDetail] = useState(null);
  const [, navigate] = useLocation();

  useEffect(() => {
    const handler = (e) => setDetail(e.detail || {});
    window.addEventListener("upgrade-required", handler);
    return () => window.removeEventListener("upgrade-required", handler);
  }, []);

  const close = () => setDetail(null);
  const go = () => {
    const url = detail?.upgradeUrl || "/plans";
    close();
    navigate(url);
  };

  return (
    <Modal opened={!!detail} onClose={close} title="Upgrade required" centered>
      <Stack>
        <Group wrap="nowrap" align="flex-start">
          <ThemeIcon color="yellow" variant="light" size="lg" radius="md">
            <IconLock size={18} />
          </ThemeIcon>
          <Text>
            {detail?.message ||
              "This action isn't available on your current plan. Upgrade to unlock it."}
          </Text>
        </Group>
        <Group justify="flex-end">
          <Button variant="default" onClick={close}>
            Not now
          </Button>
          <Button onClick={go}>View plans</Button>
        </Group>
      </Stack>
    </Modal>
  );
}
